/* isPaidSubscriber — small helper used by AdSlot + AdSenseBanner to enforce
   "paid plans are 100% ad-free" policy. Paying subscribers (trialing or
   active) never see ads anywhere on the site. Free-tier, school, and
   logged-out users see ads. Admins see ads too (so they can QA). */
export function isPaidSubscriber(user) {
    if (!user) return false;
    const s = (user.subscription_status || '').toLowerCase();
    return s === 'active' || s === 'trialing';
}
